/**
 * Axios base URL: host only, or host + `/api` when prefix mode is on.
 *
 * .env options:
 * - REACT_APP_BASE_URL=http://localhost:4000
 * - REACT_APP_USE_API_PREFIX=true → append REACT_APP_API_PREFIX (default `/api`)
 * - Or set REACT_APP_BASE_URL=http://localhost:4000/api and leave USE_API_PREFIX false
 */
export function getAxiosBaseURL() {
  const raw = (process.env.REACT_APP_BASE_URL || "").trim().replace(/\/$/, "");
  if (!raw) return "";
  const usePrefix = process.env.REACT_APP_USE_API_PREFIX === "true";
  if (!usePrefix) return raw;
  const prefix = (
    process.env.REACT_APP_API_PREFIX || "/api"
  ).replace(/\/?$/, "");
  const p = prefix.startsWith("/") ? prefix : `/${prefix}`;
  return `${raw}${p}`;
}
